var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVpnDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".vpn-dark_svg__cls-1,.vpn-dark_svg__cls-2{fill-rule:evenodd;fill:#fff}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Product Icons"
  }, /*#__PURE__*/React.createElement("path", {
    className: "vpn-dark_svg__cls-1",
    d: "M14.73 11.28h4.18v1.38h-4.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "vpn-dark_svg__cls-1",
    d: "M17.95 6.12h1.38v11.71h-1.38z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "vpn-dark_svg__cls-2",
    x: 16.3,
    y: 17.32,
    width: 4.68,
    height: 4.68,
    rx: 0.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "vpn-dark_svg__cls-2",
    x: 16.3,
    y: 2,
    width: 4.68,
    height: 4.68,
    rx: 0.28
  }), /*#__PURE__*/React.createElement("path", {
    className: "vpn-dark_svg__cls-1",
    d: "M6.98 11.28h4.28v1.38H6.98z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "vpn-dark_svg__cls-2",
    x: 3.03,
    y: 9.63,
    width: 4.68,
    height: 4.68,
    rx: 0.28
  }), /*#__PURE__*/React.createElement("path", {
    className: "vpn-dark_svg__cls-2",
    d: "M13 14.17a2.2 2.2 0 112.2-2.2 2.19 2.19 0 01-2.2 2.2zm0-3.57a1.38 1.38 0 101.33 1.4A1.37 1.37 0 0013 10.6z"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNHB4IiBoZWlnaHQ9IjI0cHgiIHZpZXdCb3g9IjAgMCAyNCAyNCI+CjxkZWZzPgo8c3R5bGU+LmNscy0xe2ZpbGw6I2ZmZjt9LmNscy0xLC5jbHMtMiwuY2xzLTN7ZmlsbC1ydWxlOmV2ZW5vZGQ7fS5jbHMtMntmaWxsOiNmZmY7fS5jbHMtM3tmaWxsOiNmZmY7fTwvc3R5bGU+CjwvZGVmcz4KPHRpdGxlPkljb25fMjRweF9WUE4tMDFfQ29sb3I8L3RpdGxlPgo8ZyBkYXRhLW5hbWU9IlByb2R1Y3QgSWNvbnMiPgo8ZyA+CjxyZWN0IGNsYXNzPSJjbHMtMSIgeD0iMTQuNzMiIHk9IjExLjI4IiB3aWR0aD0iNC4xOCIgaGVpZ2h0PSIxLjM4Ii8+CjxyZWN0IGNsYXNzPSJjbHMtMSIgeD0iMTcuOTUiIHk9IjYuMTIiIHdpZHRoPSIxLjM4IiBoZWlnaHQ9IjExLjcxIi8+CjxyZWN0IGNsYXNzPSJjbHMtMiIgeD0iMTYuMyIgeT0iMTcuMzIiIHdpZHRoPSI0LjY4IiBoZWlnaHQ9IjQuNjgiIHJ4PSIwLjI4Ii8+CjxyZWN0IGNsYXNzPSJjbHMtMiIgeD0iMTYuMyIgeT0iMiIgd2lkdGg9IjQuNjgiIGhlaWdodD0iNC42OCIgcng9IjAuMjgiLz4KPHJlY3QgY2xhc3M9ImNscy0xIiB4PSI2Ljk4IiB5PSIxMS4yOCIgd2lkdGg9IjQuMjgiIGhlaWdodD0iMS4zOCIvPgo8cmVjdCBjbGFzcz0iY2xzLTIiIHg9IjMuMDMiIHk9IjkuNjMiIHdpZHRoPSI0LjY4IiBoZWlnaHQ9IjQuNjgiIHJ4PSIwLjI4Ii8+CjxwYXRoIGNsYXNzPSJjbHMtMiIgZD0iTTEzLDE0LjE3YTIuMiwyLjIsMCwxLDEsMi4yLTIuMkEyLjE5LDIuMTksMCwwLDEsMTMsMTQuMTdabTAtMy41N0ExLjM4LDEuMzgsMCwxLDAsMTQuMzMsMTIsMS4zNywxLjM3LDAsMCwwLDEzLDEwLjZaIi8+CjwvZz48L2c+PC9zdmc+";
export { SvgVpnDark as ReactComponent };